/*
 * **********************************************
 * **********************************************
 * Proxy Contact forms
 * 
 * How to create a new form :
 * ****!! First of all, a new endpoint should be created in the proxyapp !!****
 * 1. Determine a key for your form, example : media-inquiries
 * 2. Created a snippet named with your key (contact-{{key}}) and add the attribute data-form-{{key}} to the form tag
 * 3. Add a new option and condition (for the snippet) in section proxy-contact-form.liquid file in the settings proxy_contact_type to select your new form
 * 4. Create your form in the snippet but make sure you have all the input related to the endpoint found in the swagger doc (see below).
 * 5. Add the key in the mapEndpoint constant in this JS file.
 * 6. Add your event listement initForm({{key}}) at the end of this document
 * 
 * SWAGGER DOCS : https://{{proxyUrl}}}/api/documentation
 * 
 * HELPERS : 
 * Language Selection :
 * You don't need to add the language input in the snippets, 
 * if there is no language input, we will add the current language in the endpoint (like it's always a mandatory data).
 * If you really want to have a language selection, you need to add a select input and options values should be fr and en
 * 
 * Date picker :
 * 1. Add a text input with attribute data-date-picker
 * 
 * Store selection : 
 * 1. Add a container with id : stores-container
 * 2. Add a load more button with id : load-more-button
 * 3. Add a text input with attribute : data-store-search
 * 
 * Radio button with condition input (see full example in snippets/contact-media-enquiries.liquid)
 * 1. Create a container with attribute data-choose-type that contain all your radio button
 * 2. Add also to this div the name of the input radio with attribute data-type (example : data-type="communication_type")
 * 3. The value of each radio button should be the same as the value of the input you want to appear
 * 4. Add container for each input with the attribute of the data-type and add the name of the input you want to change
 *    The div should have for example those attributes : communication_type="phone" data-type-id="communication_type"
 *    Inside you will have your input with the same name as communication_type, so in this example it's will be phone
 * So when we will click on the phone radio button, the input phone will appear.
 * **********************************************
 * **********************************************
*/

const environments = {
  devqa: "proxy-qa",
  staging_and_production: "proxy"
};
const env = window.location.href.indexOf("dev") !== -1 ? environments.devqa : environments.staging_and_production;

let language = document.documentElement.getAttribute("lang");
if(language == "en-CA") language = "en";
if(language == "fr-CA") language = "fr";

const storesContainer = document.getElementById('stores-container');
const loadMoreButton = document.getElementById('load-more-button');

let allStores = [];
let displayedCount = 0;
const initialDisplayCount = 4;
const loadIncrement = 4;

let codeRemainingAttempts = 3;

// Endpoints from Proxy App

const mapEndpoint = {
  'csrf-token' : `/apps/${env}/get-csrf-token`,
  'store-contact-form': `/apps/${env}/store/contact`,
  'contact-basic': `/apps/${env}/contact/contact-us`,
  'media-inquiries': `/apps/${env}/contact/media-inquiries`,
  'renew-contact-lenses': `/apps/${env}/store/renew-contact-lenses`,
  'get-nearest-store': `/apps/${env}/stores/by-coordinates`,
  'get-inventory-stores': `/apps/${env}/inventory/store-availabilities`,
};

/* COMMON AND HELPERS */

const phoneMaskOptions = {
  mask: '(#00) #00-0000',
  definitions: {
    '#': /[2-9]/i
  }
};

const formatPhoneNumber = (phoneNumber) => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  
  if (cleaned.length === 10) {
      const areaCode = cleaned.slice(0, 3);
      const middlePart = cleaned.slice(3, 6);
      const lastPart = cleaned.slice(6);
      
      return `(${areaCode}) ${middlePart}-${lastPart}`;
  }
  //If the phone number is not valid, do nothing just return the same phone number
  return phoneNumber;
};

const formatPostalCode = (postalCode) => {
  const cleaned = ('' + postalCode).replace(/\s+/g, '').toUpperCase();
  
  if (cleaned.length === 6) {
      return cleaned.slice(0, 3) + ' ' + cleaned.slice(3);
  }
  
  //If the zipcode is not valid, do nothing just return the same zipcode
  return postalCode;
};

const convertMetersToKilometers = (meters) => {
  if (typeof meters !== 'number' || isNaN(meters)) {
      return '';
  }

  const kilometers = meters / 1000;
  return kilometers.toFixed(2) + ' km'; 
};

/* END COMMON AND HELPERS */

/* REQUESTS */

const requestCsrfToken = async () => {
  const result = await fetch(mapEndpoint['csrf-token']);
  try{
    const json = await result.json();
    return json.csrf_token;
  }catch(error){
    console.error('Error getting Csrf token:', error);
    return false;
  }
}

const requestPostEndpoint = async (endpoint, data, csrfToken) => {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken
      },
      body: JSON.stringify(data)
    });
    return response;
}

const requestGetEndpoint = async (endpoint) => {
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  });
  return response;
}
/* END REQUESTS */

/* DATE PICKER */
const initDatePicker = (datePicker) => {
  const format = "yyyy-mm-dd";

  const startViewParam = {
    decades: 3,
    years: 2,
    monthes: 1,
    days: 0
  }
    
  const subtractYears = (date, years) => {
    date.setFullYear(date.getFullYear() - years);
  
    return date;
  }
  
  const currentDate = new Date();
  const maxDate = subtractYears(currentDate, 14);

  new Datepicker(datePicker, {
    format,
    language,
    startView: startViewParam.years,
    autohide: true,
    minDate: new Date("01-01-1900"),
    maxDate: maxDate
  }); 

  const { MaskInput } = Maska

  new MaskInput("[data-mask]")
}

/* END DATE PICKER */

const initChooseType = (chooseTypeField,form) => {
    const type = chooseTypeField.getAttribute('data-type');
    const radioButtons = form.querySelectorAll('input[name="'+ type +'"]');

    function handleRadioChange(radioButton,field) {
      const inputs = form.querySelectorAll('[data-type-id="'+ type +'"]');
      inputs.forEach(input => {
        input.classList.add('hidden');
      });
      if (radioButton.checked) {
        field.classList.remove('hidden');
      } 
    }
    radioButtons.forEach(radioButton => {
      let field = form.querySelector('['+type+'="'+radioButton.value+'"]');
      radioButton.addEventListener('change', () => handleRadioChange(radioButton, field));
    });

} 


/* *********** STORE SELECTION *********** */
const initStoreInput = async (searchInput) => {
    // Attach the event handler to the button
  loadMoreButton.addEventListener('click', handleLoadMore);
  // Lazily initialize and replace the legacy input with the new PlaceAutocompleteElement

    if (searchInput.dataset.gmapsPacInit === "1") return;
    searchInput.dataset.gmapsPacInit = "1";

    const { PlaceAutocompleteElement } = await google.maps.importLibrary("places");

    // Create the new element and configure it
    const pac = new PlaceAutocompleteElement({
      includedRegionCodes: ["ca"],
    });
    
    pac.addEventListener('gmp-select', async ({ placePrediction }) => {
      const place = placePrediction.toPlace();

      await place.fetchFields({
        fields: [ 'location']
      });
      
      if (!place.location) return;

      storesContainer.innerHTML = '';
      allStores = [];
      displayedCount = 0;

      try {
        const url = mapEndpoint['get-nearest-store']+'?latitude='+place.location.lat()+'&longitude='+place.location.lng();
        const response = await requestGetEndpoint(url);
        const data = await response.json();
        if (data && data.stores) {
            allStores = data.stores;
            displayStores(initialDisplayCount);
        }
      } catch (error) {
          console.error('Error fetching stores:', error);
      }
    });
    // Replace the old input with the new element in the DOM

    pac?.Dg?.setAttribute('placeholder', searchInput.getAttribute('data-placeholder') || '');

    searchInput.appendChild(pac)

}

const displayStores = (count) => {
  const storesToDisplay = allStores.slice(displayedCount, displayedCount + count);

  storesToDisplay.forEach(store => {
      const storeDiv = document.createElement('div');
      const phone = formatPhoneNumber(store.phone);
      const zipcode = formatPostalCode(store.postal_code);
      const province = (language == 'fr') ? store.province_fr : store.province_en;
      const distance = convertMetersToKilometers(store.distance);
      storeDiv.className = 'store';

      const radioInput = document.createElement('input');
      radioInput.type = 'radio';
      radioInput.id = `store-${store.store_number}`;
      radioInput.name = 'store_code';
      radioInput.value = store.store_number;

      const label = document.createElement('label');
      label.htmlFor = radioInput.id;
      label.innerHTML = `
      <div class="store-content">
        <div class="details">
            <div class="title">${store.name}</div>
            <div class="detail address">
            ${store.address} ${store.address2}, ${province}, ${zipcode}
            </div>
            <a href="tel:${phone}" class="detail phone">
            <span>
             <svg xmlns="" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67282 2.91896C6.59287 1.99891 8.13259 2.18846 8.80202 3.30418L10.7414 6.53641C11.2135 7.32337 11.0895 8.33068 10.4406 8.97962L9.41418 10.006C9.62395 10.4361 10.1502 11.2661 11.445 12.5609C12.7399 13.8558 13.5699 14.382 14 14.5918L15.0264 13.5654C15.6753 12.9165 16.6826 12.7925 17.4696 13.2646L20.7018 15.204C21.8175 15.8734 22.0071 17.4131 21.087 18.3332L18.5785 20.8417C18.022 21.3982 17.2186 21.7574 16.3381 21.6477C14.5913 21.4302 10.6451 20.5512 7.02369 16.9952C3.36808 13.4056 2.53246 9.38658 2.34212 7.6338C2.24806 6.76762 2.60684 5.98495 3.15109 5.44069L5.67282 2.91896ZM7.08703 4.33317L4.56531 6.8549C4.37504 7.04518 4.31234 7.25134 4.33043 7.41788C4.4908 8.89468 5.21028 12.4115 8.42496 15.5681C11.6322 18.7174 15.1085 19.4791 16.5852 19.6631C16.7574 19.6845 16.9705 19.6212 17.1642 19.4275L19.6728 16.919L16.4406 14.9796L15.2623 16.1579C14.9231 16.4971 14.3039 16.8325 13.5879 16.5846C12.8943 16.3445 11.7523 15.6967 10.0308 13.9751C8.30928 12.2536 7.66149 11.1117 7.42133 10.418C7.17346 9.70204 7.50888 9.0829 7.84807 8.7437L9.02637 7.5654L7.08703 4.33317Z" fill="#313579"/>
                    </svg>
            </span>
            <span>${phone}</span>
            </a>
    </div>
      <div class="distance-from-postal-code">${distance}</div>
                       
      `;

      storeDiv.appendChild(radioInput);
      storeDiv.appendChild(label);
      storeDiv.addEventListener('click', () => {
        radioInput.checked = true;
        storesContainer.querySelectorAll('.store').forEach(div => div.classList.remove('selected'));
        storeDiv.classList.add('selected');
    });

    storesContainer.appendChild(storeDiv);
  });

  displayedCount += count;

  if (displayedCount >= allStores.length) {
      loadMoreButton.classList.add('hidden');
  } else {
    loadMoreButton.classList.remove('hidden');
  }
};

const handleLoadMore = () => {
  displayStores(loadIncrement);
};

/* *********** END STORE SELECTION *********** */

/* *********** CUSTOM FORM VALIDATIONS ************* */

const storeValidation = (form) => {
  const selectedRadio = form.querySelector('input[name="store_code"]:checked');
  const errorMessage = form.querySelector("[data-status-error-store-missing]");
  if (selectedRadio) {
    return true; 
  } else {
      showMessage(errorMessage);
      return false; 
  }
};

/* *********** END CUSTOM FORM VALIDATIONS ************* */


const initForm = (formId, isCorporateForm = false) => {
  let form = document.querySelector("[data-form-"+formId+"]");
  
  if(!form) return;

  let recaptchaKey =  form.getAttribute('data-sitekey');
  let submitButton = form.querySelector('button[type="submit"]');
  let phoneFields = form.querySelectorAll("[data-validation-phone]")
  let textFields = form.querySelectorAll("[data-validation-text]")
  let postalcodeFields = form.querySelectorAll("[data-validation-zip]")
  let emailFields = form.querySelectorAll("[data-validation-email]")
  let dobFields = form.querySelectorAll("[data-validation-dob]")
  let datePickers = form.querySelectorAll("[data-date-picker]");
  let storeSearchField = form.querySelector("[data-store-search]");
  let chooseTypeFields = form.querySelectorAll("[data-choose-type]");
  let storeInput = false;

  phoneFields.forEach(phoneField => {
    IMask(phoneField, phoneMaskOptions);
  });

  //Init date picker if exist
  datePickers.forEach(datePicker => {
    initDatePicker(datePicker);
  });

  //Init Field type (radio button that will display a other field if checked)
  chooseTypeFields.forEach(chooseTypeField => {
    initChooseType(chooseTypeField,form);
  });
  

  //Init store selection if exist
  if (storeSearchField) {
    initStoreInput(storeSearchField);
    storeInput = true;
  };

  const onFormSubmit = async (e) => {
    let basicNesting = 1;
    let nesting = 2;
    let isStoreValid = true;
    let isPhonesValid = true;
    let isEmailsValid = true;
    let isTextFieldsValid = true;
    let isPostalCodeFieldsValid = true;
    let isDobFieldsValid = true;
    e.preventDefault();
    e.stopImmediatePropagation();
    if(storeInput) {
      isStoreValid = storeValidation(form);
    }

    for (const phoneField of phoneFields) {
      let parentContainer = phoneField.parentElement;
      if (parentContainer.classList.contains('hidden')) continue;

      const isFieldPhoneValid = notEmptyField(phoneField, basicNesting, errorKeys.enterValidPhone) 
                                && await isValidPhone(phoneField);

      if (!isFieldPhoneValid && isPhonesValid) {
        isPhonesValid = false;
      }
    }

    emailFields.forEach(emailField => {
      let parentContainer = emailField.parentElement;
      if (isCorporateForm) {
        parentContainer = parentContainer.parentElement;
      }
      if(parentContainer.classList.contains('hidden')){
        return;
      }
      const isValidFieldEmailAddress = notEmptyField (emailField, basicNesting, errorKeys.enterValidEmail) && isValidEmail(emailField);
      if(!isValidFieldEmailAddress && isEmailsValid){
        isEmailsValid = false;
      }
    });
    textFields.forEach(textField => {
      let parentContainer = textField.parentElement;
      if(parentContainer.classList.contains('hidden')){
        return;
      }
      const isValidFieldText = notEmptyField (textField, basicNesting, errorKeys.thisFieldIsRequired);
      if(!isValidFieldText && isTextFieldsValid){
        isTextFieldsValid = false;
      }
    });

    postalcodeFields.forEach(postalcodeField => {
      let parentContainer = postalcodeField.parentElement;
      if(parentContainer.classList.contains('hidden')){
        return;
      }
      const isPostalCodeValid = notEmptyField (postalcodeField, basicNesting, errorKeys.enterValidPostalCode) && isValidPostalCode(postalcodeField);
      if( !isPostalCodeValid && isPostalCodeFieldsValid){
        isPostalCodeFieldsValid = false;
      }
    });

    dobFields.forEach(dobField => {
      let parentContainer = dobField.parentElement;
      if(parentContainer.classList.contains('hidden')){
        return;
      }
      const isDateOfBirthEmpty = !notEmptyField (dobField, nesting, errorKeys.enterValidDate) && isValidDob(dobField);
      if( isDateOfBirthEmpty && isPostalCodeFieldsValid){
        isDobFieldsValid = false;
      }
    });
    

    if(isStoreValid
      && isPhonesValid
      && isPostalCodeFieldsValid
      && isEmailsValid
      && isTextFieldsValid
      && isPostalCodeFieldsValid
      && isDobFieldsValid
    ) {
      submitButton.disabled = true;
      grecaptcha.ready(function() {
        grecaptcha.execute(recaptchaKey, {action: 'submit'}).then(function(token) {
            sendSubmission(token,formId);
        });
      })
    }

    // scrall to the top of the form to see error messages

    const firstErrorElement = form.querySelector(`.${errorInputClassName}`);
    if (firstErrorElement) {
      const yOffset = -40; 
      const elementPosition = firstErrorElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition + yOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    
  }
  form.addEventListener('submit', onFormSubmit);
}

async function sendSubmission(token,formId) {
  const url = mapEndpoint[formId]+'?g-recaptcha-response='+token;
  let form = document.querySelector("[data-form-"+formId+"]");
  let submitButton = form.querySelector('button[type="submit"]');
  let checkboxes = form.querySelectorAll('input[type="checkbox"]');
  let successMessage = form.querySelector("[data-status-success]");
  let errorMessage = form.querySelector("[data-status-error]");
  let storeSearchField = form.querySelector("[data-store-search]");
  let formData = new FormData(form);
  let dataObject = Object.fromEntries(formData);

  checkboxes.forEach(checkbox => {
      dataObject[checkbox.name] = (checkbox.checked) ? true : false; 
  });

  if (dataObject['language'] === undefined) {
    dataObject['language'] = language;
  }

  try {
    let csrfToken = await requestCsrfToken();
    if(csrfToken == false) {
      showMessage(errorMessage);
    }

    const response = await requestPostEndpoint(url, dataObject, csrfToken);
    const json = await response.json();
      
    if(json.status) {
      form.reset();
    if (storeSearchField) {
      storesContainer.innerHTML = '';
      loadMoreButton.classList.add('hidden');
    };

      showMessage(successMessage);
    } else {
      showMessage(errorMessage);
    }
    submitButton.disabled = false;
  } catch (error) {
    showMessage(errorMessage);
    console.error('Error occurred while making request:', error);
  }
}

function showMessage(messageElement) {
  messageElement.classList.add("fade-in");
  setTimeout(() => {
    messageElement.classList.remove("fade-in");
  }, 5000); 
}

document.addEventListener("DOMContentLoaded", async () => {
  initForm('renew-contact-lenses');
});
